import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form"];

  connect() {
  }

  save(e) {
    e.preventDefault();
    this.formTarget.requestSubmit();
  }
}
